import type { Action } from '@jack-henry/frontend-utils/types';
import { css, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { TmBaseComponent } from '../tm-base.component';

export const tagName = 'tm-widget-button';
@customElement(tagName)
export class TmWidgetButton extends TmBaseComponent {
    @property({ type: String })
    public label = '';

    @property({ type: Object })
    public icon: TemplateResult<2> | undefined;

    @property({ type: Number })
    public approvals = 0;

    @property({ type: Boolean })
    public disabled = false;

    @property({ type: Function })
    public action: Action = () => {};

    @property({ type: Function })
    public keyup: Action = () => {};

    protected render() {
        return html`<div
            class=${classMap({
                'flex flex-col items-center relative w-20 p-4': true,
                'feature-disabled': this.disabled,
            })}
            @click=${() => this.action()}
            @keyup=${() => this.keyup()}
        >
            <div class="action-button-icon w-8 mb-1">${this.icon}</div>

            <div
                class=${classMap({
                    'absolute top-2.5 right-3.5 inline-flex items-center justify-center min-w-4 h-4 px-1 rounded-full text-xs text-[--badge-text] whitespace-nowrap': true,
                    'bg-[--badge-background]': this.approvals === 0,
                    'bg-[--jh-color-red-500] text-white': this.approvals !== 0,
                })}
            >
                ${this.approvals}
            </div>
            <div class="text-center">${this.label}</div>
        </div>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    --badge-text: var(--jh-color-gray-900);
                    --badge-background: var(--tm-color-gray-medium-30);
                }
                :host([theme='dark']) {
                    --badge-text: var(--jh-color-gray-100);
                    --badge-background: var(--tm-color-gray-light-30);
                }
                .action-button-icon svg {
                    width: 100%;
                    height: auto;
                }
                .action-button-icon path {
                    fill: var(--content-action);
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmWidgetButton;
    }
}
